import React, { useState } from 'react';
import api from '../utils/api';

export default function ProspectImport({ onImported, onClose }) {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const upload = async (preview) => {
    setBusy(true);
    setError('');
    const form = new FormData();
    form.append('file', file);
    form.append('preview', String(preview));
    try {
      const response = await api.post('/hosts/prospects/import', form);
      setResult(response.data);
      if (!preview) onImported();
    } catch (e) {
      setError(e.response?.data?.error || 'Import failed. Please try again.');
    } finally { setBusy(false); }
  };
  return (
    <section className="card card-pad" aria-label="Import host prospects" style={{ marginBottom: 20 }}>
      <h2>Import host prospects</h2>
      <p>Upload the Practicum Prospects workbook. New organizations become inactive prospects.
        Existing hosts keep their agreements, availability and contact details. Matching programs
        and outreach notes are added without creating duplicate records.</p>
      <input type="file" accept=".xlsx" disabled={busy} aria-label="Prospect workbook"
        onChange={e => { setFile(e.target.files[0] || null); setResult(null); setError(''); }} />
      {error && <p role="alert" style={{ color: '#b42318' }}>{error}</p>}
      {result && (
        <div role="status">
          <p><strong>{result.preview ? 'Preview' : 'Import complete'}:</strong> {result.sourceRows} spreadsheet rows;
            {' '}{result.newProspects} new prospects; {result.matchedExisting} existing organizations matched;
            {' '}{result.consolidatedRows} repeated rows consolidated; {result.reviewRows} rows held for review.</p>
          {result.reviewRows > 0 && (
            <details>
              <summary>Review possible duplicates (these rows were not imported)</summary>
              <p>Check these against the named existing records before adding or updating them manually.</p>
              <ul>{result.review.map((r, i) => (
                <li key={`${r.source}-${i}`}>
                  <strong>{r.organization}</strong> — {r.city}, {r.province} ({r.program}).
                  {' '}Possible matches: {r.candidates.map(c => `${c.organization} (#${c.id})`).join('; ')}
                </li>
              ))}</ul>
            </details>
          )}
        </div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 16 }}>
        <button className="btn btn-primary" disabled={busy || !file || (result && !result.preview)}
          onClick={() => upload(true)}>{busy ? 'Processing…' : 'Preview import'}</button>
        {result?.preview && (
          <button className="btn btn-primary" disabled={busy} onClick={() => upload(false)}>
            Confirm import
          </button>
        )}
        <button className="btn btn-ghost" disabled={busy} onClick={onClose}>Close</button>
      </div>
      <p style={{ marginTop: 12 }}>Required columns: Program, Province, City, Organization (Practicum Host).
        Optional: Phone, Email, Website, Sector / Role fit, How to approach, Verification, Status.
        No emails are sent by this import.</p>
    </section>
  );
}
